// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teYcUP29vyDQXiUQkVkW {
    background-color: transparent;
    border: none;
    color: var(--color-primary-black);
    height: 24px;

    &:hover {
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/TextFieldClearButton/TextFieldClearButton.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,YAAY;IACZ,iCAAiC;IACjC,YAAY;;IAEZ;QACI,eAAe;IACnB;AACJ","sourcesContent":[".button {\n    background-color: transparent;\n    border: none;\n    color: var(--color-primary-black);\n    height: 24px;\n\n    &:hover {\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `teYcUP29vyDQXiUQkVkW`
};
module.exports = ___CSS_LOADER_EXPORT___;
